<template>
  <div>
    <h1 class="common__main-title">Students List</h1>
    <div class="text-danger font-weight-bold mb-4">
      <p>Students List is not initially searched.</p>
      <p>Please specify as detailed search conditions as possible, then search.</p>
    </div>
    <Search class="search"
      @changeConditions="fetchStudents"
      :initialConditions="initialConditions"
    />

    <PagerComponent class="mb-2" v-model="pager" @changePage="changePage" />
    <StudentsTable />
    <PagerComponent v-model="pager" @changePage="changePage" />
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import _ from 'lodash'

import PagerComponent from '@/components/parts/Pager.vue';
import Search from '@/components/parts/students/StudentSearch.vue';
import StudentsTable from '@/components/parts/students/StudentsTable.vue';

import { StudentConditions, Student } from '@/store/students/types'
import { RootState } from '@/store/types';
import { Pager } from '@/store/pager.types';
import { Sort } from '@/store/sort.types';
import Loading from '@/components/parts/modal/Loading.vue';

export default Vue.extend({
  components: {
    Search,
    PagerComponent,
    StudentsTable,
    Loading,
  },

  computed: {
    students(): Student[] {
      return (this.$store.state as RootState).students.students
    },
    pager(): Pager {
      return (this.$store.state as RootState).students.pager
    },
    conditions(): StudentConditions|undefined {
      return (this.$store.state as RootState).students.conditions
    },
    sort(): Sort|undefined {
      return (this.$store.state as RootState).students.sort
    },
  },

  data: (): {
    isFetchingStudents: boolean
    initialConditions: StudentConditions
    isLoading: boolean
  } => ({
    isFetchingStudents: false,
    initialConditions: {
      fiscalYear: null,
      semester: null,
      university: null,
      studentNumber: null,
      studentNameJapanese: null,
      studentName: null,
      email: null,
      courseName: null,
      levels: [],
      dayOfWeeks: [],
      periods: [],
      tutorId: null,
      tutorName: null,
      campuses: [],
      classroom: null,
      booth: null,
      specialConsideration: null,
      oldStudentNumber: null,
      isSpir: false,
      isChangeGrade: false,
    },
    isLoading: false,
  }),

  methods: {
    fetchStudents(conditions: StudentConditions) {
      if (this.isLoading) return
      this.isLoading = true
      this.$store.dispatch('fetchStudents', { conditions: _.cloneDeep(conditions), page: 1 })
        .finally(() => {
          this.isLoading = false
        })
    },
    changePage(page: number) {
      if (this.isFetchingStudents) return
      this.isFetchingStudents = true
      this.isLoading = true

      this.$store.dispatch('fetchStudents', { conditions: this.conditions, page, sortBy: this.sort })
        .then(() => {
          this.isFetchingStudents = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },

  created() {
    this.$store.commit('initializeStudents')
  },
});
</script>
